import { cn, Table } from "@kyan/ui";

import { EmptyState } from "#/components/Contents/components/EmptyState/EmptyState";
import { type RFQResponseState } from "#/services/kyan/kyan.types";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";

import { singleLegColumns } from "./SingleLegTable.config";

export interface SingleLegTableProps {
  data: RFQResponseState[];
  hasMultiLegs?: boolean;
}

export const SingleLegTable: React.FC<SingleLegTableProps> = ({
  data,
  hasMultiLegs,
}) => {
  const { market } = usePositionsDrawerMarket();
  const isEmpty = !data.length;

  return (
    <Table
      hideHeader
      data={data}
      columns={singleLegColumns}
      emptyState={
        <EmptyState
          description={`No RFQ responses for ${market.underlying} requests.`}
        />
      }
      classes={{
        wrapper: cn({
          "flex-1 overflow-y-auto": !isEmpty,
          "h-full": isEmpty,
        }),
        table: cn({
          "flex h-full flex-col": isEmpty,
          "border-b-0": hasMultiLegs,
        }),
        thead: "sticky top-0 z-10 bg-background border-b border-divider",
        tbody: cn("text-textPrimary", {
          "flex-1": isEmpty,
        }),
        loading: {
          wrapper: "first:border-t-0",
        },
      }}
    />
  );
};
